import React from 'react';
import {
  formatNumberAndDot,
  formatOnlyNumber,
  formatToCellphone,
  formatToCEP,
  formatToCpfCnpj,
  formatToMoney,
  formatToPhone,
} from '@hooks/masks';
import { useNewShipment } from './useNewShipment';
import { Button, Select, Checkbox, Input, Accordion, Divider, InputSearch } from '@components/';
import type { IUserData } from 'interfaces/user';
import { zafClient } from '@services/';

import { useCorreios } from '@contexts/';
import { useState } from 'react';

export function NewShipment() {
  const {
    errors,
    watch,
    handleBack,
    step,
    handleOnSubmit,
    isSubmitting,
    register,
    handleSubmit,
    handleStepChange,

    itensDeclaracaoConteudoFields,
    addItem,
    removeItem,

    simulacao,
    simLoading,

    optionsServico,
    optionFormaEntrada,
    optionMotivoDevolucao,
    optionsTipoPostagem,
    optionCampoFormaEntrada,
    handlePick,
    setValue,
  } = useNewShipment();

  const [tipoServico, setTipoServico] = useState('');
  const { area } = useCorreios();
  if (tipoServico != area && area != null) setTipoServico(area);

  return (
    <div className="px-[13px] py-[22.5px]">
      <h1 className="font-semibold text-[18px]">
        <span className=" text-[#2F3941]">Postagem</span>{' '}
        <span className="text-[#87929D]">• Nova</span>
      </h1>

      {step === 1 && (
        <form className="flex flex-col gap-4 mt-4 pb-32" onSubmit={handleSubmit(handleOnSubmit)}>
          <Select
            label="Serviço*"
            options={optionsServico}
            placeholder="Selecione..."
            {...register('codigoServico')}
            error={errors.codigoServico?.message}
          />

          <Select
            label="Tipo de postagem"
            options={optionsTipoPostagem}
            placeholder="Selecione..."
            {...register('tipoPostagem')}
            error={errors.tipoPostagem?.message}
          />

          <Divider />
          <p className="text-[#2F3941]">Informações do Objeto</p>
          {tipoServico == 'SAC E-COM' && (
            <InputSearch
              mode="product"
              objectTypeKey="produto"
              label="Produto (pesquisa)"
              placeholder="Digite nome/código"
              minChars={2}
              debounceMs={300}
              onSelect={async (item) => {
                if (item.kind !== 'product') return;
                await zafClient.set('ticket.customField:custom_field_38546069276180', item.id);

                const f = item.custom_object_fields;

                setValue(
                  'comprimentoInformado',
                  f.profundidade?.toString == undefined ? '' : String(f.profundidade.toFixed(2))
                );
                setValue(
                  'larguraInformada',
                  f.largura?.toString() == undefined ? '' : String(f.largura.toFixed(2))
                );
                setValue(
                  'alturaInformada',
                  f.altura?.toString() == undefined ? '' : String(f.altura.toFixed(2))
                );
                setValue(
                  'pesoInformado',
                  f.peso == undefined ? '' : String(Math.round(f.peso * 1000))
                );
                setValue('itensDeclaracaoConteudo.0.conteudo', item.name ?? '');
              }}
            />
          )}
          <Input
            label="Comprimento (cm)*"
            placeholder="Digite o comprimento"
            {...register('comprimentoInformado')}
            error={errors.comprimentoInformado?.message}
            onInput={(e) => {
              const input = e.target as HTMLInputElement;
              input.value = formatNumberAndDot(input.value);
            }}
          />
          <Input
            label="Largura (cm)*"
            placeholder="Digite a largura"
            {...register('larguraInformada')}
            error={errors.larguraInformada?.message}
            onInput={(e) => {
              const input = e.target as HTMLInputElement;
              input.value = formatNumberAndDot(input.value);
            }}
          />
          <Input
            label="Altura (cm)*"
            placeholder="Digite a largura"
            {...register('alturaInformada')}
            error={errors.alturaInformada?.message}
            onInput={(e) => {
              const input = e.target as HTMLInputElement;
              input.value = formatNumberAndDot(input.value);
            }}
          />
          <Input
            label="Peso (g)*"
            placeholder="Digite o peso"
            {...register('pesoInformado')}
            error={errors.pesoInformado?.message}
            onInput={(e) => {
              const input = e.target as HTMLInputElement;
              input.value = formatOnlyNumber(input.value);
            }}
          />
          {itensDeclaracaoConteudoFields.map((item, index) => (
            <div key={item.id} className="flex flex-col gap-4">
              {index !== 0 && <Divider />}
              <p className="text-[#2F3941]">Item {index + 1}</p>

              {index !== 0 && (
                <InputSearch
                  mode="product"
                  objectTypeKey="produto"
                  label="Produto (objeto)"
                  placeholder="Digite nome/código"
                  initialValue={watch(`itensDeclaracaoConteudo.${index}.conteudo`)}
                  minChars={2}
                  debounceMs={300}
                  onSelect={async (item) => {
                    if (item.kind !== 'product') return;
                    await zafClient.set('ticket.customField:custom_field_38546069276180', item.id);

                    const f = item.custom_object_fields;

                    setValue(
                      `itensDeclaracaoConteudo.${index}.conteudo`,
                      item.custom_object_fields?.codigo_do_produto ?? ''
                    );
                    setValue(`itensDeclaracaoConteudo.${index}.quantidade`, '1');
                    setValue(
                      `itensDeclaracaoConteudo.${index}.valor`,
                      f?.valor_base ? String(f.valor_base) : '0'
                    );
                  }}
                />
              )}

              {index === 0 && (
                <Input
                  label="Nome do produto*"
                  placeholder="Digite o nome do produto"
                  {...register(`itensDeclaracaoConteudo.${index}.conteudo`)}
                  error={errors.itensDeclaracaoConteudo?.[index]?.conteudo?.message}
                />
              )}
              <Input
                label="Quantidade*"
                placeholder="Digite a quantidade"
                {...register(`itensDeclaracaoConteudo.${index}.quantidade`)}
                error={errors.itensDeclaracaoConteudo?.[index]?.quantidade?.message}
              />
              <Input
                label="Valor*"
                placeholder="Digite o valor"
                {...register(`itensDeclaracaoConteudo.${index}.valor`)}
                error={errors.itensDeclaracaoConteudo?.[index]?.valor?.message}
                onInput={(e) => {
                  const input = e.target as HTMLInputElement;
                  input.value = formatToMoney(input.value);
                }}
              />

              {index !== 0 && (
                <Button
                  className="w-full"
                  type="button"
                  disabled={isSubmitting}
                  onClick={() => removeItem(index)}
                >
                  Remover item
                </Button>
              )}
              <Divider />
            </div>
          ))}

          <Button
            className="w-full rounded-[8px]"
            type="button"
            isPrimary
            disabled={isSubmitting}
            onClick={() => addItem({ conteudo: '', quantidade: '', valor: '' })}
          >
            Adicionar
          </Button>
          <Divider />
          <p className="text-[#2F3941]">Dados da operação</p>
          <Select
            label="Tipo de Postagem*" // Forma de entrada
            options={optionFormaEntrada}
            placeholder="Selecione..."
            {...register('operacao.formaEntrada')}
            error={errors.operacao?.formaEntrada?.message}
            onChange={(e) => {
              // Quando selecionar "A - Autorização de Postagem", marcar postagem reversa como true
              if (e.target.value === 'A') {
                setValue('logisticaReversa', true);
              }
            }}
          />

          {tipoServico != 'SAC AT' && (
            <Input
              label="Preço pré-postagem"
              placeholder="Digite o preço"
              {...register(`precoPrePostagem`)}
              error={errors.precoPrePostagem?.message}
              onInput={(e) => {
                const input = e.target as HTMLInputElement;
                input.value = formatToMoney(input.value);
              }}
            />
          )}
          <div>
            <Checkbox
              label="Postagem reversa"
              checked={watch('logisticaReversa')}
              {...register('logisticaReversa')}
              disabled={watch('operacao.formaEntrada') === 'CA'}
            />
            {watch('operacao.formaEntrada') === 'CA' && (
              <span className="text-[12px] text-gray-400">
                Campo postagem reversa desabilitada por conta do tipo de postagem
              </span>
            )}
          </div>
          {tipoServico != 'SAC AT' && (
            <Input
              label="Referência"
              placeholder="Digite a referência"
              {...register('operacao.referencia')}
              error={errors.operacao?.referencia?.message}
            />
          )}
          <Divider />
          <p className="text-[#2F3941]">Remetente</p>
          <Input
            label="Nome do remetente*"
            placeholder="Digite o nome do remetente"
            {...register('remetente.nome')}
            error={errors.remetente?.nome?.message}
          />
          <Input
            label="CPF/CNPJ do remetente*"
            placeholder="Digite o CPF/CNPJ do remetente"
            {...register('remetente.cpfCnpj')}
            error={errors.remetente?.cpfCnpj?.message}
            onInput={(e) => {
              const input = e.target as HTMLInputElement;
              input.value = formatToCpfCnpj(input.value);
            }}
          />
          <Input
            label="E-mail do remetente*"
            placeholder="Digite o e-mail do remetente"
            {...register('remetente.email')}
            error={errors.remetente?.email?.message}
          />
          <Input
            label="Telefone do remetente*"
            placeholder="(99) 9999-9999"
            {...register('remetente.telefone')}
            error={errors.remetente?.telefone?.message}
            onInput={(e) => {
              const input = e.target as HTMLInputElement;
              input.value = formatToPhone(input.value);
            }}
          />
          <Input
            label="Celular do remetente*"
            placeholder="(99) 99999-9999"
            {...register('remetente.celular')}
            error={errors.remetente?.celular?.message}
            onInput={(e) => {
              const input = e.target as HTMLInputElement;
              input.value = formatToCellphone(input.value);
            }}
          />
          <Input
            label="Cep do remetente*"
            placeholder="Digite o cep"
            {...register('remetente.endereco.cep')}
            error={errors.remetente?.endereco?.cep?.message}
            onInput={(e) => {
              const input = e.target as HTMLInputElement;
              input.value = formatToCEP(input.value);
            }}
          />
          <Input
            label="Logradouro do remetente*"
            placeholder="Digite o logradouro"
            {...register('remetente.endereco.logradouro')}
            error={errors.remetente?.endereco?.logradouro?.message}
          />
          <Input
            label="Complemento do remetente*"
            placeholder="Digite o complemento"
            {...register('remetente.endereco.complemento')}
            error={errors.remetente?.endereco?.complemento?.message}
          />
          <Input
            label="Número do remetente*"
            placeholder="Digite o número"
            {...register('remetente.endereco.numero')}
            error={errors.remetente?.endereco?.numero?.message}
          />
          <Input
            label="Bairro do remetente*"
            placeholder="Digite o bairro"
            {...register('remetente.endereco.bairro')}
            error={errors.remetente?.endereco?.bairro?.message}
          />
          <Input
            label="Cidade do remetente*"
            placeholder="Digite a cidade"
            {...register('remetente.endereco.cidade')}
            error={errors.remetente?.endereco?.cidade?.message}
          />
          <Input
            label="UF do remetente*"
            placeholder="Digite a UF"
            {...register('remetente.endereco.uf')}
            error={errors.remetente?.endereco?.uf?.message}
          />
          <Divider />
          <p className="text-[#2F3941]">Destinatário</p>

          {/* TODO: Colocar simbolo de search */}
          <InputSearch
            onSelect={(user) => handlePick(user as unknown as IUserData)}
            placeholder="Digite o nome/cnpj/código posto do destinatário"
            minChars={2}
            debounceMs={300}
            label="Buscar destinatário"
          />

          <Input
            label="Nome do destinatário*"
            placeholder="Digite o nome do destinatário"
            {...register('destinatario.nome')}
            error={errors.destinatario?.nome?.message}
          />
          <Input
            label="CPF/CNPJ do destinatário*"
            placeholder="Digite o CPF/CNPJ do destinatário"
            {...register('destinatario.cpfCnpj')}
            error={errors.destinatario?.cpfCnpj?.message}
            onInput={(e) => {
              const input = e.target as HTMLInputElement;
              input.value = formatToCpfCnpj(input.value);
            }}
          />
          <Input
            label="E-mail do destinatário*"
            placeholder="Digite o e-mail do destinatário"
            {...register('destinatario.email')}
            error={errors.destinatario?.email?.message}
          />
          <Input
            label="Telefone do destinatário*"
            placeholder="(99) 9999-9999"
            {...register('destinatario.telefone')}
            error={errors.destinatario?.telefone?.message}
            onInput={(e) => {
              const input = e.target as HTMLInputElement;
              input.value = formatToPhone(input.value);
            }}
          />
          <Input
            label="Celular do destinatário*"
            placeholder="(99) 99999-9999"
            {...register('destinatario.celular')}
            error={errors.destinatario?.celular?.message}
            onInput={(e) => {
              const input = e.target as HTMLInputElement;
              input.value = formatToCellphone(input.value);
            }}
          />
          <Input
            label="Cep do destinatário*"
            placeholder="Digite o cep"
            {...register('destinatario.endereco.cep')}
            error={errors.destinatario?.endereco?.cep?.message}
            onInput={(e) => {
              const input = e.target as HTMLInputElement;
              input.value = formatToCEP(input.value);
            }}
          />
          <Input
            label="Logradouro do destinatário*"
            placeholder="Digite o logradouro"
            {...register('destinatario.endereco.logradouro')}
            error={errors.destinatario?.endereco?.logradouro?.message}
          />
          <Input
            label="Complemento do destinatário*"
            placeholder="Digite o complemento"
            {...register('destinatario.endereco.complemento')}
            error={errors.destinatario?.endereco?.complemento?.message}
          />
          <Input
            label="Número do destinatário*"
            placeholder="Digite o número"
            {...register('destinatario.endereco.numero')}
            error={errors.destinatario?.endereco?.numero?.message}
          />
          <Input
            label="Bairro do destinatário*"
            placeholder="Digite o bairro"
            {...register('destinatario.endereco.bairro')}
            error={errors.destinatario?.endereco?.bairro?.message}
          />
          <Input
            label="Cidade do destinatário*"
            placeholder="Digite a cidade"
            {...register('destinatario.endereco.cidade')}
            error={errors.destinatario?.endereco?.cidade?.message}
          />
          <Input
            label="UF do destinatário*"
            placeholder="Digite a UF"
            {...register('destinatario.endereco.uf')}
            error={errors.destinatario?.endereco?.uf?.message}
          />
          <Divider />
          <p className="text-[#2F3941]">Informações do conteúdo</p>
          <InputSearch
            mode="nota-fiscal"
            objectTypeKey="nota-fiscal"
            label="Nota Fiscal (pesquisa)"
            placeholder="Digite nome/código"
            minChars={2}
            debounceMs={300}
            onSelect={async (item) => {
              if (item.kind != 'nota-fiscal') return;
              setValue('chaveNFe', item.custom_object_fields.chave_nf_e);
              setValue(
                'numeroNotaFiscal',
                item.custom_object_fields.nota_fiscal + '-' + item.custom_object_fields.serie
              );
            }}
          />
          <Input
            label="Nota fiscal e série"
            placeholder="Digite o número (Ex: XXXXXX-14)"
            {...register('numeroNotaFiscal')}
            error={errors.numeroNotaFiscal?.message}
          />

          {tipoServico != 'SAC AT' && (
            <Input
              label="Chave da NFe"
              placeholder="Digite a UF"
              {...register('chaveNFe')}
              error={errors.chaveNFe?.message}
            />
          )}

          <Divider />
          <Input
            label="Prazo"
            placeholder="Digite o prazo da postagem em dias"
            {...register(`prazoPostagem`)}
            error={errors.prazoPostagem?.message}
            type="number"
            onChange={(e) => {
              const now = new Date().toISOString().split('T')[0];
              const add = Number(e.target.value) * 86400000;
              const newDate = new Date(now).getTime() + add;

              setValue('dataValidade', new Date(newDate).toISOString().split('T')[0]);
            }}
          />

          {tipoServico != 'SAC AT' && (
            <Input
              label="Data de validade*"
              placeholder="Digite a data de validade"
              {...register(`dataValidade`)}
              error={errors.dataValidade?.message}
              type="date"
              onChange={(e) => {
                const to = new Date(e.target.value).toISOString().split('T')[0]; //.split("-").map(val => Number(val));
                const now = new Date().toISOString().split('T')[0]; //.split("-").map(val => Number(val));
                const dif = (new Date(to).getTime() - new Date(now).getTime()) / 86400000;

                setValue('prazoPostagem', String(dif));
              }}
            />
          )}

          <Input
            label="Estabelecimento"
            placeholder="Digite o estabelecimento"
            {...register(`estabelecimento`)}
            error={errors.estabelecimento?.message}
          />

          <Select
            label="Motivo da devolução"
            placeholder="Selecione..."
            {...register(`motivoDevolucao`)}
            error={errors.motivoDevolucao?.message}
            options={optionMotivoDevolucao}
          />

          {tipoServico == 'SAC E-COM' && (
            <Select
              label="Forma de entrada"
              placeholder="Selecione..."
              {...register(`campoFormaEntrada`)}
              error={errors.campoFormaEntrada?.message}
              options={optionCampoFormaEntrada}
            />
          )}

          <div className="border border-[#D8DCDE] py-2 px-4 rounded-[8px] text-[12px] flex flex-col gap-2">
            <p>Simulação da postagem</p>

            <div className="flex justify-between">
              <p className="w-1/2 text-[#87929D]">Valor</p>
              <p>
                {simLoading
                  ? 'Calculando...'
                  : simulacao?.valor != null
                    ? `R$ ${simulacao.valor}`
                    : '—'}
              </p>
            </div>

            <div className="flex justify-between">
              <p className="w-1/2 text-[#87929D]">Prazo</p>
              <p>
                {simLoading
                  ? 'Calculando...'
                  : simulacao?.prazoDiasUteis != null
                    ? `${simulacao.prazoDiasUteis} dias úteis`
                    : '—'}
              </p>
            </div>
          </div>

          <div
            className="fixed inset-x-0 bottom-0 z-50 bg-white border-t border-[#D8DCDE]
                py-4 pb-[calc(env(safe-area-inset-bottom)+1rem)]"
          >
            <div className="mx-auto max-w-5xl flex flex-col gap-4 px-4">
              <Button
                className="w-full rounded-[8px]"
                type="submit"
                isPrimary
                // disabled={isSubmitting}
              >
                Prosseguir
              </Button>
              <Button className="w-full" type="button" disabled={isSubmitting} onClick={handleBack}>
                Cancelar
              </Button>
            </div>
          </div>
        </form>
      )}

      {/* TODO: COMPONENTIZAR ESSA PARTE */}
      {/* TODO: Fazer uma lista dinamica e colocar uma diferenca como props para os textos que sao diferentes */}
      {step == 2 && (
        <>
          <h2 className="text-[14px] font-semibold mt-[0.90625rem]">
            Revise os dados da postagem:
          </h2>
          <div className="flex flex-col gap-4 mt-4 pb-32">
            <Accordion
              items={{
                title: 'Dados da postagem',
                content: (
                  <React.Fragment>
                    <div className="grid grid-cols-2 items-center mb-2">
                      <p className="text-[#87929D]">Serviço</p>
                      <div>
                        <p className="bg-[#E9EBED] inline-block py-[2px] px-[8px] text-center truncate">
                          {watch('codigoServico')}
                        </p>
                      </div>
                    </div>
                    <div className="grid grid-cols-2 items-center mb-2">
                      <p className="text-[#87929D]">Tipo de postagem</p>
                      <div>
                        <p className="bg-[#E9EBED] inline-block py-[2px] px-[8px] text-center truncate">
                          {watch('tipoPostagem') ?? '---'}
                        </p>
                      </div>
                    </div>
                    <div className="grid grid-cols-2 items-center mb-2">
                      <p className="text-[#87929D]">Código do objeto</p>
                      <div>
                        <p className="bg-[#E9EBED] inline-block py-[2px] px-[8px] text-center truncate">
                          {watch('codigoObjeto') ?? '---'}
                        </p>
                      </div>
                    </div>
                    <div className="grid grid-cols-2 items-center mb-2">
                      <p className="text-[#87929D]">Comprimento</p>
                      <div>
                        <p className="font-normal py-[2px] px-[8px]">
                          {watch('comprimentoInformado')}
                        </p>
                      </div>
                    </div>
                    <div className="grid grid-cols-2 items-center mb-2">
                      <p className="text-[#87929D]">Largura</p>
                      <div>
                        <p className="font-normal py-[2px] px-[8px]">{watch('larguraInformada')}</p>
                      </div>
                    </div>
                    <div className="grid grid-cols-2 items-center mb-2">
                      <p className="text-[#87929D]">Altura</p>
                      <div>
                        <p className="font-normal py-[2px] px-[8px]">{watch('alturaInformada')}</p>
                      </div>
                    </div>
                    <div className="grid grid-cols-2 items-center mb-2">
                      <p className="text-[#87929D]">Diâmetro</p>
                      <div>
                        <p className="font-normal py-[2px] px-[8px]">0</p>
                      </div>
                    </div>
                    <div className="grid grid-cols-2 items-center mb-2">
                      <p className="text-[#87929D]">Peso</p>
                      <div>
                        <p className="font-normal py-[2px] px-[8px]">{watch('pesoInformado')}</p>
                      </div>
                    </div>

                    <div className="grid grid-cols-2 items-center mb-2">
                      <p className="text-[#87929D]">Tipo de entrada</p>
                      <div>
                        <p className="font-normal py-[2px] px-[8px]">
                          {watch('operacao.tipoEntrada')}
                        </p>
                      </div>
                    </div>
                    <div className="grid grid-cols-2 items-center mb-2">
                      <p className="text-[#87929D]">Forma de entrada</p>
                      <div>
                        <p className="font-normal py-[2px] px-[8px]">
                          {watch('operacao.formaEntrada')}
                        </p>
                      </div>
                    </div>
                    <div className="grid grid-cols-2 items-center mb-2">
                      <p className="text-[#87929D]">Postagem reversa</p>
                      <div>
                        <p className="font-normal py-[2px] px-[8px]">
                          {watch('logisticaReversa') ? 'Sim' : 'Não'}
                        </p>
                      </div>
                    </div>
                    <div className="grid grid-cols-2 items-center mb-2">
                      <p className="text-[#87929D]">Referência</p>
                      <div>
                        <p className="font-normal py-[2px] px-[8px]">
                          {watch('operacao.referencia')}
                        </p>
                      </div>
                    </div>
                    <div className="grid grid-cols-2 items-center mb-2">
                      <p className="text-[#87929D]">Nome do remetente</p>
                      <div>
                        <p className="font-normal py-[2px] px-[8px]">{watch('remetente.nome')}</p>
                      </div>
                    </div>
                    <div className="grid grid-cols-2 items-center mb-2">
                      <p className="text-[#87929D]">CPF/CNPJ do remetente</p>
                      <div>
                        <p className="font-normal py-[2px] px-[8px]">
                          {watch('remetente.cpfCnpj')}
                        </p>
                      </div>
                    </div>
                    <div className="grid grid-cols-2 items-center mb-2">
                      <p className="text-[#87929D]">E-mail do remetente</p>
                      <div>
                        <p className="font-normal py-[2px] px-[8px]">{watch('remetente.email')}</p>
                      </div>
                    </div>

                    <div className="grid grid-cols-2 items-center mb-2">
                      <p className="text-[#87929D]">Telefone do remetente</p>
                      <div>
                        <p className="font-normal py-[2px] px-[8px]">
                          {watch('remetente.telefone')}
                        </p>
                      </div>
                    </div>
                    <div className="grid grid-cols-2 items-center mb-2">
                      <p className="text-[#87929D]">Celular do remetente</p>
                      <div>
                        <p className="font-normal py-[2px] px-[8px]">
                          {watch('remetente.celular')}
                        </p>
                      </div>
                    </div>

                    <div className="grid grid-cols-2 items-center mb-2">
                      <p className="text-[#87929D]">Cep do remetente</p>
                      <div>
                        <p className="font-normal py-[2px] px-[8px]">
                          {watch('remetente.endereco.cep')}
                        </p>
                      </div>
                    </div>

                    <div className="grid grid-cols-2 items-center mb-2">
                      <p className="text-[#87929D]">Logradouro do remetente</p>
                      <div>
                        <p className="font-normal py-[2px] px-[8px]">
                          {watch('remetente.endereco.logradouro')}
                        </p>
                      </div>
                    </div>
                    <div className="grid grid-cols-2 items-center mb-2">
                      <p className="text-[#87929D]">Numero do remetente</p>
                      <div>
                        <p className="font-normal py-[2px] px-[8px]">
                          {watch('remetente.endereco.numero')}
                        </p>
                      </div>
                    </div>
                    <div className="grid grid-cols-2 items-center mb-2">
                      <p className="text-[#87929D]">Bairro do remetente</p>
                      <div>
                        <p className="font-normal py-[2px] px-[8px]">
                          {watch('remetente.endereco.bairro')}
                        </p>
                      </div>
                    </div>
                    <div className="grid grid-cols-2 items-center mb-2">
                      <p className="text-[#87929D]">Cidade do remetente</p>
                      <div>
                        <p className="font-normal py-[2px] px-[8px]">
                          {watch('remetente.endereco.cidade')}
                        </p>
                      </div>
                    </div>
                    <div className="grid grid-cols-2 items-center mb-2">
                      <p className="text-[#87929D]">UF do remetente</p>
                      <div>
                        <p className="font-normal py-[2px] px-[8px]">
                          {watch('remetente.endereco.uf')}
                        </p>
                      </div>
                    </div>

                    <div className="grid grid-cols-2 items-center mb-2">
                      <p className="text-[#87929D]">Nome do destinatario</p>
                      <div>
                        <p className="font-normal py-[2px] px-[8px]">
                          {watch('destinatario.nome')}
                        </p>
                      </div>
                    </div>
                    <div className="grid grid-cols-2 items-center mb-2">
                      <p className="text-[#87929D]">CPF/CNPJ do destinatario</p>
                      <div>
                        <p className="font-normal py-[2px] px-[8px]">
                          {watch('destinatario.cpfCnpj')}
                        </p>
                      </div>
                    </div>
                    <div className="grid grid-cols-2 items-center mb-2">
                      <p className="text-[#87929D]">E-mail do destinatario</p>
                      <div>
                        <p className="font-normal py-[2px] px-[8px]">
                          {watch('destinatario.email')}
                        </p>
                      </div>
                    </div>

                    <div className="grid grid-cols-2 items-center mb-2">
                      <p className="text-[#87929D]">Telefone do destinatario</p>
                      <div>
                        <p className="font-normal py-[2px] px-[8px]">
                          {watch('destinatario.telefone')}
                        </p>
                      </div>
                    </div>
                    <div className="grid grid-cols-2 items-center mb-2">
                      <p className="text-[#87929D]">Celular do destinatario</p>
                      <div>
                        <p className="font-normal py-[2px] px-[8px]">
                          {watch('destinatario.celular')}
                        </p>
                      </div>
                    </div>

                    <div className="grid grid-cols-2 items-center mb-2">
                      <p className="text-[#87929D]">Cep do destinatario</p>
                      <div>
                        <p className="font-normal py-[2px] px-[8px]">
                          {watch('destinatario.endereco.cep')}
                        </p>
                      </div>
                    </div>

                    <div className="grid grid-cols-2 items-center mb-2">
                      <p className="text-[#87929D]">Logradouro do destinatario</p>
                      <div>
                        <p className="font-normal py-[2px] px-[8px]">
                          {watch('destinatario.endereco.logradouro')}
                        </p>
                      </div>
                    </div>
                    <div className="grid grid-cols-2 items-center mb-2">
                      <p className="text-[#87929D]">Numero do destinatario</p>
                      <div>
                        <p className="font-normal py-[2px] px-[8px]">
                          {watch('destinatario.endereco.numero')}
                        </p>
                      </div>
                    </div>
                    <div className="grid grid-cols-2 items-center mb-2">
                      <p className="text-[#87929D]">Bairro do destinatario</p>
                      <div>
                        <p className="font-normal py-[2px] px-[8px]">
                          {watch('destinatario.endereco.bairro')}
                        </p>
                      </div>
                    </div>
                    <div className="grid grid-cols-2 items-center mb-2">
                      <p className="text-[#87929D]">Cidade do destinatario</p>
                      <div>
                        <p className="font-normal py-[2px] px-[8px]">
                          {watch('destinatario.endereco.cidade')}
                        </p>
                      </div>
                    </div>
                    <div className="grid grid-cols-2 items-center mb-2">
                      <p className="text-[#87929D]">UF do destinatario</p>
                      <div>
                        <p className="font-normal py-[2px] px-[8px]">
                          {watch('destinatario.endereco.uf')}
                        </p>
                      </div>
                    </div>

                    {watch('itensDeclaracaoConteudo').map((item) => {
                      return (
                        <>
                          <Divider />
                          <div className="grid grid-cols-2 items-center mb-2">
                            <p className="text-[#87929D]">Conteúdo</p>
                            <div>
                              <p className="font-normal py-[2px] px-[8px]">{item.conteudo}</p>
                            </div>
                          </div>

                          <div className="grid grid-cols-2 items-center mb-2">
                            <p className="text-[#87929D]">Quantidade</p>
                            <div>
                              <p className="font-normal py-[2px] px-[8px]">{item.quantidade}</p>
                            </div>
                          </div>

                          <div className="grid grid-cols-2 items-center mb-2">
                            <p className="text-[#87929D]">Valor</p>
                            <div>
                              <p className="font-normal py-[2px] px-[8px]">{item.valor}</p>
                            </div>
                          </div>
                        </>
                      );
                    })}

                    <Divider />

                    <div className="grid grid-cols-2 items-center mb-2">
                      <p className="text-[#87929D]">Prazo</p>
                      <div>
                        <p className="font-normal py-[2px] px-[8px]">
                          {watch('prazoPostagem') ?? '---'}
                        </p>
                      </div>
                    </div>

                    <div className="grid grid-cols-2 items-center mb-2">
                      <p className="text-[#87929D]">Data de validade</p>
                      <div>
                        <p className="font-normal py-[2px] px-[8px]">{watch('dataValidade')}</p>
                      </div>
                    </div>

                    <div className="grid grid-cols-2 items-center mb-2">
                      <p className="text-[#87929D]">Simulação prazo</p>
                      <div>
                        <p className="font-normal py-[2px] px-[8px]">
                          {simulacao?.prazoDiasUteis ?? '—'} dias úteis
                        </p>
                      </div>
                    </div>

                    <div className="grid grid-cols-2 items-center mb-2">
                      <p className="text-[#87929D]">Simulação preço</p>
                      <div>
                        <p className="font-normal py-[2px] px-[8px]">
                          {simulacao?.valor != null ? `R$ ${simulacao.valor}` : '—'}
                        </p>
                      </div>
                    </div>

                    <div className="grid grid-cols-2 items-center mb-2">
                      <p className="text-[#87929D]">Observações</p>
                      <div>
                        <p className="font-normal py-[2px] px-[8px]">
                          {watch('observacao') ?? '---'}
                        </p>
                      </div>
                    </div>

                    <div className="grid grid-cols-2 items-center mb-2">
                      <p className="text-[#87929D]">Estabelecimento</p>
                      <div>
                        <p className="font-normal py-[2px] px-[8px]">
                          {watch('estabelecimento') ?? '---'}
                        </p>
                      </div>
                    </div>

                    <div className="grid grid-cols-2 items-center mb-2">
                      <p className="text-[#87929D]">Motivo devolução</p>
                      <div>
                        <p className="font-normal py-[2px] px-[8px]">
                          {watch('motivoDevolucao') ?? '---'}
                        </p>
                      </div>
                    </div>

                    <div className="grid grid-cols-2 items-center mb-2">
                      <p className="text-[#87929D]">Forma de entrada</p>
                      <div>
                        <p className="font-normal py-[2px] px-[8px]">
                          {watch('campoFormaEntrada') ?? '---'}
                        </p>
                      </div>
                    </div>
                  </React.Fragment>
                ),
              }}
            />
          </div>
          <div
            className="fixed inset-x-0 bottom-0 z-50 bg-white border-t border-[#D8DCDE]
                py-4 pb-[calc(env(safe-area-inset-bottom)+1rem)]"
          >
            <div className="mx-auto max-w-5xl flex flex-col gap-4 px-4">
              <Button
                className="w-full rounded-[8px]"
                isPrimary
                onClick={() => handleStepChange()}
                disabled={isSubmitting}
              >
                Finalizar postagem
              </Button>
              <Button className="w-full" type="button" onClick={handleBack} disabled={isSubmitting}>
                Voltar
              </Button>
            </div>
          </div>
        </>
      )}
    </div>
  );
}
